import styled from 'styled-components';

export const Wrapper = styled.main`
  position: relative;
  padding: 8px 30px 70px;
  @media (max-width: 767px) {
    padding-left: 16px;
    padding-right: 16px;
  }
  min-height: calc(100vh - 120px);
`;
